import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNl = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 9 6",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			fill: "#21468B",
			width: 9,
			height: 6
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#FFF",
			width: 9,
			height: 4
		}),
		/* @__PURE__ */ _jsx("rect", {
			fill: "#AE1C28",
			width: 9,
			height: 2
		})
	]
});
export default SvgNl;
